import api from "@/services/api";

export default {
    namespaced: true,
    state: () => ({
        companyInfo: [
            {
                title: "Address",
                detail:
                    "Postal: 30N Gould St #47338, Sheridan WY 82801, Wyomming, Sheridan 82801 Abd • Main: 1029 Mountain Road PL NE STE N, ALBUQUERQUE, NM 87110 ABD",
                icon: "bi bi-geo-alt-fill",
            },
            { title: "Phone", detail: "+1 (812) 220-2156", icon: "bi bi-telephone-fill" },
            { title: "Email", detail: "info@56yellowrosesllc.com", icon: "bi bi-envelope-fill" },
        ],
    }),
    actions: {
        async sendMessage(_, form) {
            try {
                const response = await api.post("/Contact/create", {
                    fullName: form.name,
                    email: form.email,
                    subject: form.subject,
                    message: form.message
                });
                return response.data;
            } catch (error) {
                console.error("Mesaj gönderme hatası:", error.response?.data || error.message);
                throw error;
            }
        }
    },
    getters: {
        getCompanyInfo: (state) => state.companyInfo
    }
};
